import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useFormik, FormikContext } from "formik";
import Switch from '@material-ui/core/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { setGetViewAdmin } from '../../store/thunk/setGetViewAdmin';
import { useRouter } from '../../../../../@casino/useRouter';
import { setPostUpdateViewAdmin } from '../../store/thunk/setPostUpdateViewAdmin';
import { Allow as AllowMap} from '../../../../settings/allow';

const AdminView = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const { id } = router?.query;

    React.useEffect(() => {
        dispatch(setGetViewAdmin({ id }))
    }, [id])

    const onSubmit = (store) => {
        let str = '';
        for (let key in store) {

            if (store[key]) {
                str += key + ','
            }
        }
        if (str[str.length - 1] === ',') {
            str = str.slice(0, str.length - 1)
        }
        dispatch(setPostUpdateViewAdmin({
            id,
            allows: str
        }))
    }

    const initialValues = useSelector((state) => state.admin.view);
    const enableReinitialize = true;
    const formik = useFormik({ onSubmit, initialValues, enableReinitialize });
    
    const GetPages = ({ label, values, name, onChange }) => {
        return (
            <label htmlFor="" style={{ width: '30%' }}>
                <span style={{ color: '#fff' }}>{label}</span>
                <Switch
                    checked={values}
                    onChange={onChange}
                    color="primary"
                    name={name}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
            </label>
        )
    }
    const Allow = AllowMap(formik.values);
    const NewAllow = [];
    
    for (let key in Allow) {
        NewAllow.push(Allow[key]);
    }
    console.log(formik.values)
    return (
        <div style={{ padding: 20, paddingTop: 0 }}>
            <Title label="Настройка доступа" />
            <div style={{
                padding: 20,
                background: '#1b2039',
                borderRadius: 8,
            }}>
                <h3 style={{ margin: 0, padding: 0, color: '#fff' }}>Доступные разделы</h3>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit} style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        {
                            NewAllow?.map((item) => <GetPages label={item.label} values={item.values} onChange={() => formik.setFieldValue(item.allow, !item.values)} name={item.allow} />)
                        } 
                        <button type="submit">Сохранить</button>
                    </form>
                </FormikContext.Provider>

            </div>
        </div>
    )
}

export default AdminView;